'use strict';
/* global __ENV_IS_BBC__:false, __DEBUG__:false, __WATCH__:false, __SHORTCUTS_ENABLED__:false */
/**
 * Import stylesheets
 */
import './../scss/main.scss';
/**
 * ES6
 */
import 'core-js';
/**
 * PHASER + SPINE
 */
import 'pixi';
import 'p2';
import 'phaser';
import App from './App';
import DeviceController from 'app/controller/DeviceController';
const checkExists = (lib, id) => {
  if (typeof lib === 'undefined') {
    console.error('Library Missing :\t', id);
  }
};

checkExists(PIXI, 'PIXI');
checkExists(p2, 'p2');
checkExists(Phaser, 'Phaser');

/* detecting touch - used for css hover states */
const touch =
  'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
document.querySelector('html').className += touch ? ' touch' : ' no-touch';

window.PhaserGlobal = { hideBanner: true };

/**
 * Add dom to gameContainerId
 */
const add_dom = (el_id) => {
  const gamewrap = document.createElement('div');
  gamewrap.setAttribute('id', 'game_container');
  gamewrap.className = 'canvas_container absolute_center page_background';
  // gamewrap.innerHTML = '<ui></ui>';
  document.getElementById(el_id).appendChild(gamewrap);
  return gamewrap;
};

/**
 * Start app
 */
const start = (gamewrap) => {
  const deviceController = new DeviceController();

  Phaser.Device.whenReady(() => {
    new App({ dom_element: gamewrap, deviceController });
  });
};

/**
 * Add css to html head
 */
const add_css = (gameDir) => {
  let ss = document.createElement('link');
  ss.type = 'text/css';
  ss.rel = 'stylesheet';
  ss.href = './css/main.css';
  document.getElementsByTagName('head')[0].appendChild(ss);
};

if (!__ENV_IS_BBC__) {
  add_css();
  document.addEventListener('DOMContentLoaded', () => {
    const gamewrap = add_dom('og-game-holder');
    start(gamewrap);
  });
}



// WEBPACK FOOTER //
// ./js/main.js